
import times from './times'
import ProcessTimeSlots from './ProcessTimeSlots'
import pipe from './pipe'
import pile from './pile'
import classNames from 'classnames'

function uuid(a){return a?(a^Math.random()*16>>a/4).toString(16):([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,uuid)}
function defer() {
    let resolve;
    let reject;
    let promise = new Promise((_resolve, _reject)=>{
        resolve = _resolve
        reject = _reject
    })
    promise.resolve = resolve;
    promise.reject = reject;
    return promise
}
function arrayToJSONByID(data){
    let _data = {}
    if(Array.isArray(data)){
        _data = {}
        data.forEach((value)=>{
            _data[value.id] = value
        })
    } else {
        _data = data
    }
    return _data;
}
function isOrganizationIntegrated(organization){
    for(let integration of Object.values(organization.integrations)){
        if(integration.pim == true && integration.active == true) return true
    }
    return false
}
export {
    times,
    ProcessTimeSlots,
    pipe,
    pile,
    uuid,
    classNames,
    defer,
    arrayToJSONByID,
    isOrganizationIntegrated
}


// WEBPACK FOOTER //
// ./lib/helpers/index.js